<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary" show-arrows>
      <v-tab href="#LiveAuction" ripple>{{ $t('live_auction') }}</v-tab>
      <v-tab href="#DashboardAuction" ripple>{{ $t('dashboard') }}</v-tab>
    </v-tabs>
    <template>
      <component
        v-if="currentView"
        :is="currentView"
        :auctionId.sync="auctionId"
        @setAuctionId="setAuctionId"
        v-model="currentView"
      ></component>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LiveAuction from '@/components/view/liveAuction/LiveAuction'
import DashboardAuction from '@/components/view/liveAuction/DashboardAuction'
export default {
  components: {
    LiveAuction,
    DashboardAuction
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  data: function() {
    return {
      currentView: null,
      auctionId: null
    }
  },
  mounted() {},
  methods: {
    setAuctionId(auctionId) {
      const vm = this
      vm.auctionId = auctionId
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/liveAuction/Controller.vue